import React from 'react';
import { StyleSheet } from 'react-native';
import { Text, withTheme } from '@rneui/themed';
import { usePlaybackMetrics } from '../../hooks/player';
import { useOnScrub } from '../../hooks/player';
import { View, Slider } from '../elements';
import { chapterLocator, getFormattedProgressAndRemainingTime } from '../..';
export const UnthemedProgressBar = ({ disableTime = false, chapters }) => {
    const { position, duration, timeRemainingShort: completeTimeRemainingShort, } = usePlaybackMetrics();
    const onScrub = useOnScrub();
    const isChaptered = chapters && chapters.length > 0;
    let relativePosition = position;
    let relativeDuration = duration;
    let currentChapter;
    if (isChaptered) {
        const chapter = chapterLocator(chapters, position);
        currentChapter = chapter.current;
        const next = chapter.next ? chapters[chapter.next] : undefined;
        const nextLocation = next ? next.location : duration;
        relativePosition = position - chapter.current.location;
        relativeDuration = nextLocation - chapter.current.location;
    }
    const { timeProgressed, timeRemaining, } = getFormattedProgressAndRemainingTime(relativePosition, relativeDuration);
    return (React.createElement(View, { style: styles.wrapperStyle },
        React.createElement(Slider, { value: relativeDuration ? (relativePosition || 0) / relativeDuration : 0, maximumValue: 1, minimumValue: 0, onSlidingComplete: (val) => {
                const to = currentChapter ?
                    currentChapter.location + (relativeDuration * val) :
                    (duration * val);
                return onScrub(position, to);
            } }),
        !disableTime && React.createElement(View, { style: { flexDirection: 'row', height: 'auto' } },
            React.createElement(View, { style: { flex: 1 } },
                React.createElement(Text, { style: { fontSize: 13, textAlign: 'left' } }, timeProgressed)),
            isChaptered ? (React.createElement(View, { style: { flex: 1 } },
                React.createElement(Text, { style: { fontSize: 13, textAlign: 'center' } }, completeTimeRemainingShort))) : null,
            React.createElement(View, { style: { flex: 1 } },
                React.createElement(Text, { style: { fontSize: 13, textAlign: 'right' } }, timeRemaining)))));
};
const styles = StyleSheet.create({
    wrapperStyle: {
        alignItems: 'stretch',
        justifyContent: 'center',
        width: '100%',
    },
});
export const ProgressBar = withTheme(UnthemedProgressBar, 'ProgressBar');
//# sourceMappingURL=ProgressBar.js.map